import { Component, Input, OnDestroy, HostBinding, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthService } from '../../auth.service';
import { AuthState } from '../../auth-state';
import { User } from '../../user';
import { LoggerService } from 'src/app/core/logger/logger.service';
import { AbstractForm } from 'src/app/shared/utils/abstract-form';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-confirm-sign-in',
  templateUrl: './confirm-sign-in-component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmSignInComponent extends AbstractForm implements OnDestroy{

  cellphone = '';
  _show: boolean;

  messageSubscription:Subscription;
  message = '';

  private showStates = [AuthState.CONFIRM_SIGN_IN];
  private _authState = null;
  @HostBinding('className') className = '';

  constructor(
    protected formBuilder: FormBuilder,
    logger: LoggerService,
    private authService: AuthService) {
      super(formBuilder, logger);

      this.messageSubscription = authService.messages$.subscribe(msg => {
        this.message = msg?.msg || '';
      });

  }
  ngOnDestroy(){
    this.messageSubscription.unsubscribe();
  }

  @Input()
  set authState(authState: AuthState) {
    this._show = this.showStates.filter(item => item === authState.state).length > 0;
    if (authState.user && this._show) {
      this.cellphone = authState.user?.challengeParam?.CODE_DELIVERY_DESTINATION || '';
      this._authState = authState.user;
      this.setControlValue('code',authState.user.verificationCode);
    }
    this.className = this._show? 'active' : '';
  }

  buildFormGroup(): FormGroup {
    return this.formBuilder.group({
      code: ['', [Validators.minLength(6), Validators.maxLength(6)]]
    });
  }
  updateControls() {}
  updateObject(): any {
  }

  getUser() {
    this._authState.verificationCode = this.getControlValue('code');
    return this._authState;
  }

  onConfirm() {
    this.authService.confirmSignIn(this.getUser());
  }

  onSignIn() {
    this.authService.changeAuthState(AuthState.SIGN_IN, null);
  }
}
